'use client';

import { VercelToolbar } from '@vercel/toolbar/next';

// 배포된 pre-production(develop/stage) 환경에서만 노출.
// 로컬 dev는 next.config 플러그인 + vercel link가 없으면 동작하지 않으므로 제외.
const isPreProduction =
  process.env.NODE_ENV === 'production' && process.env.NEXT_PUBLIC_APP_ENV !== 'production';

export function PreProductionToolbar() {
  return isPreProduction ? <VercelToolbar /> : null;
}
